import React from 'react';
import PropTypes from 'prop-types';
import { translate } from '@utils/i18n';
import { proposalsPath } from 'routes';

const namespace = 'features.proposals.index';

// The backend resolves the exported set from these params when the user picks "Select all N
// proposals entirely", so they must include the grid's search term (IP-14746). Copies the
// shared query params so repeated exports don't stack ids/all onto them.
export const buildExportUrl = (queryParams, proposalIds) => {
  const params = new URLSearchParams(queryParams);

  if (proposalIds) {
    params.append('ids', proposalIds);
  } else {
    params.append('all', true);
  }

  return `${proposalsPath({ format: 'csv' })}?${params}`;
};

function ExportCsv({ proposalIds, disabled, queryParams }) {
  const onSubmit = () => {
    window.location = buildExportUrl(queryParams, proposalIds);
  };

  return (
    <button type="button" tabIndex="0" className="qmb-control" disabled={disabled} onClick={onSubmit}>
      <i className="fa-light fa-file-export" />
      {translate('export_csv_button', { namespace })}
    </button>
  );
}

ExportCsv.propTypes = {
  proposalIds: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  disabled: PropTypes.bool.isRequired,
  queryParams: PropTypes.object.isRequired
};

ExportCsv.defaultProps = {
  proposalIds: null
};

export default ExportCsv;
